/**
 * Specialties Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import {store} from "../../store";

// States
const state = {
    questions: [],
};

// Getters
const getters = {
    questions: state => {
        return state.questions
    },
};

// Actions
const actions = {
    getQuestions(context, payload) {
        function successCallback(response) {
            context.commit('getQuestionsHandler', { questions: response.data.questions });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Question.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },
};

// Mutations
const mutations = {
    getQuestionsHandler(state, { questions }) {
        // Update questions state
        state.questions = questions;
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}